module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEMSURBVHgB1VbRDYIwEH0YBnADcQOdAJhANxAnsWziCk4ATqAj4AZuoFd7jaZpaSHthy95OeCO9+hdA2QAXkiInGNPvCIuSmIlD+QKBOJDSO0FEiO3uMaAcBmcENnA1qKWmM1ka4qFzGDjyRfExpX0GRyIN4y3rhrLLzziZ+IA1VOXiKxZY6KBFr8Tt1C9FRaTJVSLnMgt13ZQfZfiNfGJ767QsWXxjqOsGxBoYIrDENdxz7UDG9UINLCJu0yOUO+xjtmbN9hmcHGI/5ro/b6CWoF++sYszjEPwogtm8hVFD6DEuHvpIFrC+KDzwufQcWcgsaVMA0yREby78H/G+gZTNk5oZCan6Em/W15A94KM41cr02DAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/material-img.png
// module id = 1jou
// module chunks = 36